<template>
  <div class="common-no-data fb fb-col fb-cross-center fb-main-center">
    <div class="item-flex-1"></div>
    <div>
      <img
        v-if="+type === 2"
        class="icon"
        src="@/assets/images/no-attendance.png"
      />
      <img v-else class="icon" src="@/assets/images/no-honour.png" />
      <slot></slot>
      <p v-if="content" class="font-28 no-text">{{ content }}</p>
    </div>
    <div class="item-flex-2"></div>
  </div>
</template>
<script>
export default {
  name: 'commonEmpty',
  props: {
    // 2为考评组
    type: {
      type: [Number, String],
      default: 1
    },
    content: {
      type: String,
      default: '暂无数据'
    }
  },
  data() {
    return {}
  }
}
</script>
<style lang="scss" scoped>
.common-no-data {
  width: 100%;
  position: absolute;
  top: 0;
  right: 100%;
  bottom: 0;
  left: 0;
  .icon {
    display: block;
    width: 180px;
    margin: 0 auto;
  }
  .no-text {
    text-align: center;
    color: rgba(23, 26, 29, 0.4);
  }
}
</style>
